var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"error-container bg-light text-dark d-block mt-1 mb-2 text-start d-flex fw-bold"},[_c('i',{staticClass:"bi bi-exclamation-triangle-fill text-danger me-2"}),_vm._v(" \n    "+_vm._s(_vm.errorMessage)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }